import axiosService from "../../services/axiosService";

export const getGeoLocation = async (value) => {
  return axiosService.get(
    // `http://api.positionstack.com/v1/forward?access_key=d9074c7f2cabc5f01a3a90980562a45d&query=` + value
    `http://112.78.1.167:8085/api/samples/location?location=` + value
  );
};

